export class RubiconCreateAdUnitRequest {
  siteId: number;
  name: string;
  size: string;
}
